import { render, staticRenderFns } from "./linkMaga.vue?vue&type=template&id=43b72e72&"
import script from "./linkMaga.vue?vue&type=script&lang=js&"
export * from "./linkMaga.vue?vue&type=script&lang=js&"
import style0 from "./linkMaga.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports